var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('es-transition',{attrs:{"custom-style":(_vm.customStyle),"show":(_vm.show),"custom-class":(_vm.classname)},on:{"click":_vm.onClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }